<script lang="ts">
	import { onMount } from 'svelte';
	import EventCard from './EventCard.svelte';
	// import EventModal from './EventModal.svelte';
	import { get } from 'svelte/store';
	import { storeSettings } from '../../store/StoreSettings';
	import { Pagination } from 'swiper';
	import { Swiper, SwiperSlide } from 'swiper/svelte';
	import 'swiper/css/bundle';
	import 'swiper/css/pagination';
	import Modal from '../shared/Modal.svelte';
	import EventDetail from './EventDetail.svelte';

	const publicKey = get(storeSettings).publicKey;

	let events: any = [];
	onMount(async () => {
		const res = await fetch(`API_URL/events`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				publicKey: publicKey
			}
		});
		events = await res.json();
	});

	let modal;
	let selectedEvent;

	function openModal(event) {
		// selectedEvent = event;
		// modal.open();
	}
</script>

<section>
	<div class="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
		<div class="mt-4 slider">
			{#if events.length > 0}
				<Swiper
					slidesPerView={3}
					spaceBetween={10}
					grabCursor={true}
					watchOverflow={true}
					breakpoints={{
						'@0.00': {
							slidesPerView: 1
						},
						'@0.75': {
							slidesPerView: 2
						},
						'@1.00': {
							slidesPerView: 3
						}
						// '@1.50': {
						// 	slidesPerView: 4
						// }
					}}
					pagination={{
						dynamicBullets: true,
						clickable: true,
						renderBullet: function (index, className) {
							return '<span class="' + className + ' bg-pink-600" >' + (index + 1) + '</span>';
						}
					}}
					modules={[Pagination]}
				>
					{#each events as event}
						<SwiperSlide style="height:auto">
							<div on:click={() => openModal(event)} class="h-full">
								<EventCard {event} />
							</div>
						</SwiperSlide>
					{/each}
				</Swiper>
			{/if}
		</div>
	</div>

	<Modal bind:this={modal}>
		<EventDetail event={selectedEvent} />
	</Modal>
</section>
